import React from 'react';

const CareersPage = () => {
  return <>CareersPage</>;
};

export default CareersPage;
